<template>
  <th data-align="center" data-column-id="x" data-formatter="x" data-sortable="false" data-width="36px" title="Excluir" data-header-no-icon="true">...</th>
</template>

<script>
export default {
  name: 'DeleteHeader'
}
</script>
